import React from "react";
import { Play, Music, Disc, ChevronRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const versions = [{
  id: "main",
  title: "Glamour Kitty",
  artist: "Yoga Dinners",
  imageSrc: "https://electric-cat.10web.cloud/wp-content/uploads/2026/05/82EDEFF9-092E-4BEB-B409-8E8066431513.png?v=rkr70dte9mr",
  imageAlt: "Glamour Kitty Cover Art"
}, {
  id: "dub",
  title: "Glamour Kitty (Dub)",
  artist: "Yoga Dinners",
  imageSrc: "https://electric-cat.10web.cloud/wp-content/uploads/2026/05/954A7B33-F1DD-499D-8B55-28378C4B0CBD.png?v=tl4h49hcin",
  imageAlt: "Glamour Kitty Dub Cover Art"
}];
const platforms = [{
  id: 1,
  versionId: "main",
  name: "Spotify",
  url: "https://open.spotify.com/album/0drTXxlT8wDAL3kQvtuHpd",
  icon: "spotify"
}, {
  id: 2,
  versionId: "main",
  name: "Apple Music",
  url: "https://music.apple.com/us/album/glamour-kitty-single/6765820945?uo=4&app=itunes&at=1001lry3&ct=dashboard",
  icon: "apple"
}, {
  id: 3,
  versionId: "main",
  name: "iTunes",
  url: "#",
  icon: "itunes"
}, {
  id: 4,
  versionId: "dub",
  name: "Spotify",
  url: "#",
  icon: "spotify"
}, {
  id: 5,
  versionId: "dub",
  name: "Apple Music",
  url: "https://music.apple.com/us/album/galmour-kitty-dub-single/6767998496?uo=4",
  icon: "apple"
}, {
  id: 6,
  versionId: "dub",
  name: "iTunes",
  url: "https://music.apple.com/us/album/galmour-kitty-dub-single/6767998496?uo=4&app=itunes&at=1001lry3&ct=dashboard",
  icon: "itunes"
}];
const getIcon = (iconName: string) => {
  switch (iconName) {
    case "spotify":
      return <Play className="w-5 h-5" />;
    case "apple":
      return <Music className="w-5 h-5" />;
    case "itunes":
      return <Disc className="w-5 h-5" />;
    default:
      return <Play className="w-5 h-5" />;
  }
};
export default function VersionToggleStreamingPlatforms() {
  return <section id="version-toggle-streaming-platforms" className="bg-background py-16 md:py-24 relative overflow-hidden z-0">
      {}
      <div className="absolute inset-0 -z-20 overflow-hidden">
        <img src="https://electric-cat.10web.cloud/wp-content/uploads/2026/05/82EDEFF9-092E-4BEB-B409-8E8066431513.png?v=rkr70dte9mr" alt="" className="w-full h-full object-cover opacity-20 blur-3xl scale-110" loading="lazy" data-wvc-srcset="https://electric-cat.10web.cloud/wp-content/uploads/2026/05/82EDEFF9-092E-4BEB-B409-8E8066431513.png?v=rkr70dte9mr-wvc-srcset" data-wvc-sizes="https://electric-cat.10web.cloud/wp-content/uploads/2026/05/82EDEFF9-092E-4BEB-B409-8E8066431513.png?v=rkr70dte9mr-wvc-sizes" />
        <div className="absolute inset-0 bg-gradient-to-b from-background via-background/80 to-background"></div>
      </div>

      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-amber-500/3 rounded-lg blur-3xl -z-10 pointer-events-none"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-red-600/3 rounded-lg blur-3xl -z-10 pointer-events-none"></div>

      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {versions.map((version, i) => <Card key={version.id} data-index={i} className="rounded-md border border-border/20 bg-card/40 backdrop-blur-xl shadow-lg">
              <CardHeader className="flex flex-col items-center pt-10 pb-6 text-center">
                <div className="w-40 h-40 mb-6 rounded-md overflow-hidden shadow-md bg-muted">
                  <img src={version.imageSrc} alt={version.imageAlt} data-wvc-srcset={`${version.imageSrc}-wvc-srcset`} data-wvc-sizes={`${version.imageSrc}-wvc-sizes`} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <CardTitle className="text-3xl font-bold font-default mb-2 text-foreground">
                  {version.title}
                </CardTitle>
                <CardDescription className="text-lg font-medium text-muted-foreground">
                  {version.artist}
                </CardDescription>
              </CardHeader>
              <CardContent className="flex flex-col gap-4 px-6 pb-10">
                {platforms.filter(p => p.versionId === version.id).map((platform, j) => <Button key={platform.id} data-index={j} asChild variant="outline" className="w-full h-14 justify-between px-6 bg-transparent border-[#BF40BF] text-[#BF40BF] hover:bg-[#BF40BF] hover:text-background rounded-md transition-all duration-300 group shadow-sm hover:shadow-md">
                    <Link to={platform.url} newTab>
                      <div className="flex items-center gap-3">
                        {getIcon(platform.icon)}
                        <span className="text-base font-semibold">{platform.name}</span>
                      </div>
                      <ChevronRight className="w-5 h-5 opacity-70 group-hover:opacity-100 transition-opacity" />
                    </Link>
                  </Button>)}
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}